export default {
  guiaInterativo: {
    run: false,
    stepIndex: 0
  },
  achados: {
    fetching: 0,
    errors: [],
    result: []
  },
  unidade: {
    veiculos: {
      fetching: 0,
      errors: [],
      result: []
    },
    moradores: {
      fetching: 0,
      errors: [],
      result: []
    }
  },
  quantidadeErros: {
    fetching: 0,
    errors: [],
    count: 0
  },
  mudancas: {
    fetching: 0,
    errors: [],
    result: []
  },
  problema: {
    meusRegistros: {
      fetching: 0,
      result: [],
      errors: []
    },
    locais: {
      fetching: 0,
      result: [],
      errors: []
    },
    categorias: {
      fetching: 0,
      result: [],
      errors: []
    }
  },
  notificacao: {
    configuracoes: {
      fetching: 0,
      result: [],
      errors: []
    },
    notificacoes: {
      fetching: 0,
      result: [],
      errors: []
    }
  },
  consumo: {
    agua: {
      fetching: 0,
      result: [],
      errors: []
    },
    marca: "",
    marcas: {
      fetching: 0,
      result: {},
      errors: []
    },
    aguaMineral: {
      fetching: 0,
      result: [],
      errors: []
    },
    solicitacoes: {
      fetching: 0,
      result: [],
      errors: []
    },
    competencias: {
      fetching: 0,
      result: [],
      errors: []
    }
  },
  auth: {
    user: {},
    fetching: 0,
    roles: [],
    apartamentos: []
  },
  admin: {
    acessos: {
      result: [],
      fetching: 0,
      errors: []
    },
    problemas: {
      result: [],
      fetching: 0,
      errors: []
    },
    contatos: {
      result: [],
      fetching: 0,
      errors: []
    },
    roles: {
      result: [],
      fetching: 0,
      errors: []
    },
    rolesContratantes: {
      result: [],
      fetching: 0,
      errors: []
    },
    contratantes: {
      result: [],
      fetching: 0,
      errors: []
    },
    typeEventUsers: {
      result: [],
      fetching: 0,
      errors: []
    }
  },
  reserva: {
    data: {
      unidade: '',
      data_reserva: ''
    },
    list: {
      result: [],
      fetching: 0,
      errors: []
    }
  },
  agenda: {
    data: {},
    qrcodes: {
      result: [],
      fetching: 0,
      errors: []
    },
    todasAtividades: {
      result: [],
      fetching: 0,
      errors: []
    },
    config_perfis: {
      fetching: 0,
      errors: [],
      result: {
        usuarios: [],
        perfis: []
      }
    },
    config: {
      result: {
        tarefas:[],
        perfis: [],
        estimativas: {}
      },
      fetching: 0,
      errors: []
    },
    atividades: {
      result: [],
      fetching: 0,
      errors: []
    }
  },
  inicio: {
    presencas: {
      result: [],
      fetching: 0,
      errors: []
    }
  },
  calendarioPresenca: {
    fetching: 0,
    errors: [],
    result: {
      usuarios: {},
      presencas: []
    }
  },
  registroAcesso: {
    ultimosRegistros: {
      result: [],
      fetching: 0,
      errors: []
    },
    data: {
      contratante: {
        apartamento: '',
        text: ''
      },
      contratado: {
        nome: '',
        text: '',
        cpf: '',
        empresa: { nome: '' },
        funcao: { nome: '' },
        matricula: '',
        telefone: ''
      }
    },
    presencas: {
      result: [],
      fetching: 0,
      errors: []
    },
    contratados: {
      result: [],
      fetching: 0,
      errors: []
    },
    contratantes: {
      result: [],
      fetching: 0,
      errors: []
    },
    funcoes: {
      result: [],
      fetching: 0,
      errors: []
    },
    empresas: {
      result: [],
      fetching: 0,
      errors: []
    }
  }
};



// WEBPACK FOOTER //
// ./src/initialState.js